import React from 'react';
import '../App.css';
import { FaStethoscope, FaAmbulance, FaHeartbeat, FaBaby, FaMicroscope, FaSyringe, FaUserMd, FaBriefcaseMedical, FaWheelchair, FaRegHospital } from 'react-icons/fa';

const Services = () => {
  return (
    <div className="services-page">
      {/* Header */}
      <header>
        <nav className="navbar">
          <div className="logo">
            <h1>Chaman Hospital</h1>
          </div>
          <ul className="nav-links">
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/services" className="active">Services</a></li>
            <li><a href="/doctors">Doctors</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </nav>
      </header>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <h2>Our Medical Services</h2>
          <p>
            We offer a wide range of medical services to ensure your health and well-being. Our expert doctors and staff are dedicated to providing you with the best care.
          </p>

          <div className="services-list">
            <div className="service">
              <FaStethoscope className="service-icon" />
              <h3>General Consultation</h3>
              <p>Get accurate diagnosis and personalized treatment plans from our experienced physicians.</p>
            </div>
            <div className="service">
              <FaAmbulance className="service-icon" />
              <h3>Emergency Care (24/7)</h3>
              <p>Our emergency department is open round-the-clock to handle all urgent and critical care cases.</p>
            </div>
            <div className="service">
              <FaUserMd className="service-icon" />
              <h3>Surgical Procedures</h3>
              <p>Minor and major surgeries with advanced equipment and a team of expert surgeons.</p>
            </div>
            <div className="service">
              <FaMicroscope className="service-icon" />
              <h3>Laboratory & Diagnostics</h3>
              <p>Quick and reliable lab tests, imaging, and screenings with latest diagnostic tools.</p>
            </div>
            <div className="service">
              <FaHeartbeat className="service-icon" />
              <h3>Cardiology</h3>
              <p>Heart health care including ECG, ECHO, and expert treatment for cardiac conditions.</p>
            </div>
            <div className="service">
              <FaBaby className="service-icon" />
              <h3>Pediatrics</h3>
              <p>Health care for infants, toddlers, and children including vaccinations and routine check-ups.</p>
            </div>
            <div className="service">
              <FaSyringe className="service-icon" />
              <h3>Gynaecology & Maternity</h3>
              <p>Comprehensive care for women’s health, pregnancy, childbirth, and postnatal care.</p>
            </div>
            <div className="service">
              <FaWheelchair className="service-icon" />
              <h3>Physiotherapy</h3>
              <p>Recovery assistance and mobility improvement through personalized therapy programs.</p>
            </div>
            <div className="service">
              <FaBriefcaseMedical className="service-icon" />
              <h3>Free PMKVY Card Services</h3>
              <p>We accept PMKVY cards for government-funded treatments, surgeries, and tests.</p>
            </div>
            <div className="service">
              <FaRegHospital className="service-icon" />
              <h3>Ambulance Support (24/7)</h3>
              <p>Emergency ambulance available anytime with fast response across Bahadurgarh & Patiala.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="footer-content">
          <p>© {new Date().getFullYear()} Chaman Hospital. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Services;
